let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fgMbm")).then(() => parcelRequire('7aU4T'));